<template>
  <div id="wrapper">
    <!-- Sidebar -->
    <SideBarMenu />
    <!-- /#sidebar-wrapper -->
    <HeaderBarMenu v-bind:title="pageTitle" />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <div class="container-fluid">
        <div class="row filter-row row-background-color" style="padding: 10px">
          <div class="col-lg-12 row-background-color">
            <div class="row table-head-row-background-color">
              <div class="col-12">
                <span style="margin-right: 15px">Version 1.1.2</span> Released
                Date: 22-05-2024
              </div>
            </div>
            <div>
              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Moved “Required CII” column next to the “Estimated CII” column, and columns “CII Δ” and “CII Δ%”, to follow on the right.</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Removed “knots” units from the CII value while hovering above the “CII Index Compared to SOG” graph</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Renamed ship type to "Cruise Passenger Ship" to from "Cruise passenger ship having non-conventional propulsion"</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Removed "Administration" From Report PDF</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Changed unit from “gr/nm*mt” to “grCO2/nm*mt”</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Removed Parenthesis from "Full Designation Of The Country" and "Full Designation Of Competent Person or Organization"</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Removed signature section from Report PDF</div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 row-background-color">
            <div class="row table-head-row-background-color">
              <div class="col-12">
                <span style="margin-right: 15px">Version 1.1.1</span> Released
                Date: 13-12-2023
              </div>
            </div>
            <div>
              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">
                  Include version number in every page and export file
                </div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Added CII measurement unit</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">
                  Changed the preliminary rating colors to match the official
                  coloring
                </div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Removed Valid Date Column</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Added Vessel Type Column</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">
                  Re-formatted the PDF report export to match the Lloyd's
                  guidelines
                </div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Renamed Hoteling to Accommodation</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">
                  Changed the fields in the "Create Report" form and added
                  dropdonw menus for countries and cities
                </div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">
                  Added Geolocation button in "Create Report" to auto-detect the
                  country
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12 row-background-color">
            <div class="row table-head-row-background-color">
              <div class="col-12">
                <span style="margin-right: 15px">Version 1.0.1</span> Released
                Date: 13-09-2023
              </div>
            </div>
            <div>
              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">General Bug Fixes</div>
              </div>

              <div
                class="row table-head-row-background-color"
                style="background-color: rgb(43, 49, 63)"
              >
                <div class="col-12">Excel and PDF bug fixes</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
  <!-- /#wrapper -->
</template>

<script>
import Popper from "vue3-popper";
import MonitorService from "../services/monitor.service";
import ShipService from "../services/ship.service";
import UserService from "../services/user.service";
import SideBarMenu from "../components/SideBarMenu.vue";
import HeaderBarMenu from "../components/HeaderBarMenu.vue";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import AdministrationTable from "../components/AdministrationTable.vue";
import TokenService from "../services/token.service";
export default {
  name: "Versions",
  components: {
    SideBarMenu,
    HeaderBarMenu,
    Popper,
    AdministrationTable,
    MonitorService,
    UserService,
    ShipService,
  },
  data() {
    return {
      editUser: false,
      createUser: false,
      showModal: false,
      deleteUser: false,
      userTobedeleted: {},
      pageTitle: "Administration Dashboard",
      fromDate: null,
      toDate: null,
      dateValueFrom: null,
      dateValueTo: null,
      selectedShipID: 0,
      usersList: {},
      numOfRecords: 0,
      options: [],
      modalTitle: "",
      modalText: "",
      errorList: [],
      searchText: "",
      ships: [],
      shipAccesses: [],
      admin: false,
      newUser: {
        idForEdit: 0,
        name: "",
        email: "",
        RoleId: false,
        password: "",
        ShipAccesses: [],
      },
    };
  },
  computed: {
    computedRoleId() {
      return 0;
    },
    EMSUser() {
      return TokenService.getUser();
    },
    //filter user list based on user selection - filters
    filterUsersList() {
      let filterSearchText = this.searchText.toLowerCase();
      if (filterSearchText.length == 0) {
        return this.usersList;
      } else {
        let result = this.usersList.filter((user) =>
          user.Name.toLowerCase().includes(filterSearchText)
        );
        return result;
      }
    },
  },
  mounted() {
    this.getShips();
  },
  methods: {
    //email validation
    validateEmail: function (mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true;
      }
      return false;
    },
    //password validation
    validatePassword: function (password) {
      if (
        /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9\s])(?=.*[A-Z])(?=\S+$).{6,}/.test(
          password
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    //preparing to create user
    applytoCreateUser: function () {
      this.cleanTempUser();
      this.createUser = true;
    },
    //cleant temp user object before submitting to api
    cleanTempUser: function () {
      // alert("cleanTempUser")
      this.idForEdit = 0;
      this.newUser.name = "";
      this.newUser.email = "";
      this.newUser.RoleId = false;
      this.newUser.password = "";
      this.newUser.ShipAccesses = [];
    },
    //confirm to delete user
    confirmDeleteNewUser: function () {
      this.deleteUser = false;
      UserService.deleteUser(this.userTobedeleted.Id).then(
        (response) => {
          this.getShips();
        },
        (error) => {
          this.showAPIError("Delete New User", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },
    //cancel new user creation
    cancelDeleteNewUser: function () {
      this.deleteUser = false;
      this.userTobedeleted = {};
    },
    cancelFormNewUser: function () {
      this.createUser = false;
      this.editUser = false;
      this.newUser.name = "";
      this.newUser.email = "";
      this.newUser.password = "";
      this.newUser.ShipAccesses = [];
      this.admin = false;
      this.newUser.RoleId = false;
      for (let i = 0; i < this.shipAccesses.length; i++) {
        this.shipAccesses[i].Selected = false;
      }
    },
    // validate new user creation data
    submitFormEditUser: function () {
      this.errorList = [];

      let userShipAccesses = false;

      let tempshipAccesses = [];

      for (let i = 0; i < this.shipAccesses.length; i++) {
        if (this.shipAccesses[i].Selected == true) {
          userShipAccesses = true;
          tempshipAccesses.push(this.shipAccesses[i]);
        }
      }

      if (userShipAccesses == false) {
        this.errorList.push("User should have access to at least one vessel");
      }

      if (this.newUser.name.length < 5) {
        this.errorList.push("Username should have at least 5 characters");
      }

      if (!this.validateEmail(this.newUser.email)) {
        this.errorList.push("You have entered an invalid email address");
      }

      if (this.errorList.length > 0) {
        this.modalTitle = "Error";
        this.showModal = true;
        return;
      } else {
        this.newUser.ShipAccesses = tempshipAccesses;
        let userToBesubmitted = {};
        userToBesubmitted.Id = this.newUser.idForEdit;
        userToBesubmitted.Name = this.newUser.name;

        userToBesubmitted.Email = this.newUser.email;
        if (this.newUser.RoleId == true) {
          userToBesubmitted.RoleId = 1;
        } else {
          userToBesubmitted.RoleId = 0;
        }

        userToBesubmitted.ShipAccesses = this.newUser.ShipAccesses;

        this.editCurrentUser(userToBesubmitted);
      }
    },
    submitFormNewUser: function () {
      // this.cleanTempUser();
      this.errorList = [];

      let userShipAccesses = false;

      let tempshipAccesses = [];

      for (let i = 0; i < this.shipAccesses.length; i++) {
        if (this.shipAccesses[i].Selected == true) {
          userShipAccesses = true;
          tempshipAccesses.push(this.shipAccesses[i]);
        }
      }

      if (userShipAccesses == false) {
        this.errorList.push("User should have access to at least one vessel");
      }

      if (this.newUser.name.length < 5) {
        this.errorList.push("Username should have at least 5 characters");
      }

      if (!this.validateEmail(this.newUser.email)) {
        this.errorList.push("You have entered an invalid email address");
      }

      if (!this.validatePassword(this.newUser.password)) {
        this.errorList.push("You have entered an invalid password");
      }

      if (this.errorList.length > 0) {
        this.modalTitle = "Error";
        this.showModal = true;
        return;
      } else {
        this.newUser.ShipAccesses = tempshipAccesses;

        let userToBesubmitted = {};
        userToBesubmitted.Name = this.newUser.name;
        userToBesubmitted.Email = this.newUser.email;
        if (this.newUser.RoleId == true) {
          userToBesubmitted.RoleId = 1;
        } else {
          userToBesubmitted.RoleId = 0;
        }
        userToBesubmitted.password = this.newUser.password;

        userToBesubmitted.ShipAccesses = this.newUser.ShipAccesses;

        this.createNewUser(userToBesubmitted);
      }
    },
    //function that present errors from api
    showAPIError: function (title, value) {
      this.modalTitle = "Error: " + title;
      this.errorList = [];
      this.errorList.push(value);
      this.showModal = true;
    },
    //get the event of a selection of a user
    selectedTableRow: function (value) {
      this.cleanTempUser();
      this.newUser.idForEdit = value.Id;
      this.newUser.name = value.Name;
      this.newUser.email = value.Email;
      if (value.RoleId > 0) {
        this.newUser.RoleId = true;
      } else {
        this.newUser.RoleId = false;
      }

      for (let i = 0; i < this.shipAccesses.length; i++) {
        for (let j = 0; j < value.ShipAccesses.length; j++) {
          if (this.shipAccesses[i].ShipId == value.ShipAccesses[j].ShipId) {
            this.shipAccesses[i].Selected = true;
          }
        }
      }

      this.editUser = true;
    },
    //get the event of a deletion of a user
    deletedTableRow: function (value) {
      this.deleteUser = true;
      this.userTobedeleted = value;
    },
    //edit user
    editCurrentUser: function (user) {
      this.editUser = false;
      UserService.editCurrentUser(user).then(
        (response) => {
          this.getShips();
        },
        (error) => {
          this.showAPIError("Update User", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },
    //send the creation fo the user to api
    createNewUser: function (user) {
      this.createUser = false;
      UserService.createNewUser(user).then(
        (response) => {
          this.getShips();
        },
        (error) => {
          this.showAPIError("Create New User", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },
    //get users dayta
    getUsers: function () {
      UserService.getUsers().then(
        (response) => {
          this.usersList = response.data;

          for (let i = 0; i < this.usersList.length; i++) {
            if (this.usersList[i].Id == this.EMSUser.id) {
              this.shipAccesses = this.usersList[i].ShipAccesses;
              for (let i = 0; i < this.shipAccesses.length; i++) {
                for (let j = 0; j < this.ships.length; j++) {
                  if (this.shipAccesses[i].ShipId == this.ships[j].ShipId) {
                    this.shipAccesses[i].ShipName = this.ships[j].ShipName;
                    this.shipAccesses[i].Selected = false;
                  }
                }
              }
            }
          }
        },
        (error) => {
          this.showAPIError("Get Monitor Data", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },

    submitForm: function () {
      this.getUSers();
    },
    //get ships data
    getShips: function () {
      ShipService.getShipsAuth().then(
        (response) => {
          this.ships = response.data.ShipsBasicData;
          this.getUsers();
        },
        (error) => {
          this.showAPIError("Get Ships", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },
  },
};
</script>

<style scoped>
input {
  background-color: #171b25 !important;
  color: #fff !important;
}

.search {
  position: relative;
  box-shadow: 0 0 40px rgba(51, 51, 51, 0.1);
  background-color: #171b25;
}

.search input {
  height: 40px;
  text-indent: 25px;
  border: 1px solid #d6d4d4;
  color: white;
  background-color: #171b25 !important;
}

.search input:focus {
  box-shadow: none;
  border: 1px solid #d6d4d4;
}

.search .fa-search {
  position: absolute;
  top: 20px;
  left: 16px;
}

.search button {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 30px;
  width: 60px;
}

::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  width: 50%;
  border-color: #2d3748;
  background-color: #1a202c;
}

@media only screen and (max-width: 700px) {
  ::v-deep .modal-content {
    width: 80%;
  }
}

.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}

.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background-color: #1b202c;
  border-color: #2d333d;
  border-style: solid;
}

.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 18px;
  margin-top: 2px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 4px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>